// Same-origin API base, so the app works identically on every domain it's
// served from (custom domain or *.emergent.host) without depending on
// whichever one was baked into REACT_APP_BACKEND_URL at build time.
// Mirrors the pattern already used for the WebSocket connection in
// hooks/useTimerWS.js and hooks/useComms.js.
const runtimeOrigin = (typeof window !== "undefined" && window.location)
  ? window.location.origin
  : null;

export const BACKEND_URL = runtimeOrigin || process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
